import React from 'react';
import BarChartIcon from '../icons/BarChartIcon';

const STREAMS = [
  { emoji: '💵', title: '2.23x Better Arbitrage', body: "Find the highest buyer price instantly. Our data proves you'll earn 2.23x more on low-value items by checking all 4 buyers." },
  { icon: 'bar', title: 'Earn Your Subscription', body: 'Get paid 1p for every verified price point — up to 5p per barcode (4 buyers, with one offering both cash and voucher options). Check enough each month and your subscription pays for itself. Example: a £15/month tier = 300 fully-checked barcodes.' },
  { emoji: '🤝', title: 'Refer-a-Friend Passive Income', body: "Invite fellow flippers and earn ongoing monthly income for every friend who subscribes. You're paid for the duration of their subscription—true passive income that builds over time.", badge: 'Coming Soon' },
  { emoji: '🎁', title: 'Bonus Stacking', body: 'We alert you to buyer promo codes (like DEMAND15) and sign-up bonuses. Stack offers from all 4 platforms for maximum earnings.' },
  { emoji: '👥', title: 'Community Knowledge', body: 'Learn from experienced flippers in our community. Discover high-margin categories, sourcing strategies, and avoid common mistakes.' },
  { emoji: '📱', title: 'Equipment Upgrade Programme', body: 'Planned partnership programme — use your Flipping Friends earnings to work towards a smartphone or laptop. Details revealed to beta testers closer to launch.', badge: 'Planned for launch' },
];

export default function EarnSection() {
  return (
    <section className="py-24 md:py-32 px-4 sm:px-6 lg:px-8 bg-[#0A0A0A]" data-testid="earn-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#FFD700]/20 border border-[#FFD700]/30 text-[#FFD700] px-4 py-2 rounded-full text-sm font-medium mb-6">
            💰 Earn While You Learn
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Multiple Ways to <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#00D26A] to-[#FFD700]">Build Passive Income</span>
          </h2>
          <p className="text-xl text-zinc-400 max-w-3xl mx-auto leading-relaxed">
            Flipping Friends isn't just a tool—it's a complete earnings ecosystem. Build your income streams while growing your flipping business.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {STREAMS.map((s) => (
            <div key={s.title} className="bg-[#050505] border border-zinc-800/50 rounded-2xl p-6 hover:border-[#00D26A]/40 transition-colors">
              <div className="text-3xl mb-4 leading-none">
                {s.icon === 'bar' ? <BarChartIcon size="1em" /> : s.emoji}
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{s.title}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{s.body}</p>
              {s.badge && (
                <span className="inline-block mt-2 text-xs text-[#FFD700] font-semibold">{s.badge}</span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-zinc-400 mb-4 text-lg">
            <strong className="text-white">Flipping doesn't have to be lonely.</strong> Join a community that helps you earn more together.
          </p>
          <a
            href="#waitlist"
            className="inline-block bg-gradient-to-r from-[#00D26A] to-[#FFD700] text-black hover:opacity-90 font-bold px-8 py-4 rounded-full text-lg transition-all transform hover:translate-y-[-2px] shadow-[0_0_30px_rgba(0,210,106,0.3)]"
          >
            Join the Community - 3 Years Free (£540 Value)
          </a>
        </div>
      </div>
    </section>
  );
}
